import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Tags from "../elements/Tags"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". culture-1 culture-1 culture-1" ". culture-2 culture-2 culture-2" "culture-3 culture-3 culture-3 ." ". culture-4 culture-4 culture-4" "culture-5 culture-5 . ." ". . culture-6 culture-6" "culture-7 culture-7 . .";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  .culture-3 {
    grid-area: culture-3;
  }
  .culture-4 {
    grid-area: culture-4;
  }
  .culture-5 {
    grid-area: culture-5;
  }
  .culture-6 {
    grid-area: culture-6;
  }
  .culture-7 {
    grid-area: culture-7;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." ". . event-2 event-2" "culture-1 . . ." "culture-1 culture-2 . ." ". culture-2 culture-3 ." ". culture-4 culture-3 ." ". culture-4 culture-5 ." ". . culture-5 culture-6" ". . culture-7 culture-6" ". . culture-7 .";
  }
  @media (min-width: 1200px) {
  }
`

const December = () => {
  const data = useStaticQuery(graphql`
    query {
      decemberEventOne: file(
        relativePath: { eq: "events/december/event-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      decemberEventTwo: file(
        relativePath: { eq: "events/december/event-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      decemberCultureOne: file(
        relativePath: { eq: "events/december/culture-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 499, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      decemberCultureTwo: file(
        relativePath: { eq: "events/december/culture-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      decemberCultureThree: file(
        relativePath: { eq: "events/december/culture-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      decemberCultureFour: file(
        relativePath: { eq: "events/december/culture-4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      decemberCultureFive: file(
        relativePath: { eq: "events/december/culture-5.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      decemberCultureSix: file(
        relativePath: { eq: "events/december/culture-6.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      decemberCultureSeven: file(
        relativePath: { eq: "events/december/culture-7.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="december">
      <Grid>
        <Block className="event-1">
          <Photo img={data.decemberEventOne} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            Working on garage monkey - an app that helps mechanics create job
            cards, capture vehicle info and track service and repair progress.
          </h4>
          <Tags
            maxWidth={400}
            words={[
              "react",
              "reactnative",
              "graphql",
              "serverless",
              "python",
              "postgresql",
            ]}
          />
        </Block>

        <Block className="event-2">
          <Photo img={data.decemberEventTwo} maxWidth={800} maxHeight={557} />
          <h4>Working on a new brand and website for Seermont Investments.</h4>
        </Block>

        <Block className="culture-1">
          <Photo img={data.decemberCultureOne} maxWidth={500} maxHeight={499} />
          <h4 style={{ maxWidth: 500 }}>
            Sphiwe&#39;s stoked for the holidays.
          </h4>
        </Block>

        <Block className="culture-2">
          <Photo img={data.decemberCultureTwo} maxWidth={500} maxHeight={500} />
          <h4 style={{ maxWidth: 500 }}>
            And the Geek of the Year is Jason 🙌
          </h4>
        </Block>

        <Block className="culture-3">
          <Photo
            img={data.decemberCultureThree}
            maxWidth={500}
            maxHeight={500}
          />
          <h4 style={{ maxWidth: 500 }}>Simon came in 2nd. </h4>
        </Block>

        <Block className="culture-4">
          <Photo
            img={data.decemberCultureFour}
            maxWidth={500}
            maxHeight={500}
          />
          <h4 style={{ maxWidth: 500 }}>And in 3rd place we have Zego.</h4>
        </Block>
        <Block className="culture-5">
          <Photo
            img={data.decemberCultureFive}
            maxWidth={400}
            maxHeight={522}
          />
          <h4 style={{ maxWidth: 400 }}>Caroline clocked over.</h4>
        </Block>
        <Block className="culture-6">
          <Photo img={data.decemberCultureSix} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>So did Andrei, our CTO.</h4>
        </Block>
        <Block className="culture-7">
          <Photo
            img={data.decemberCultureSeven}
            maxWidth={400}
            maxHeight={522}
          />
          <h4 style={{ maxWidth: 400 }}>And Wynand, Teamgeek’s finance guy.</h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default December
